import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { HttpUtilService } from '../config/http-util.service';

@Injectable()
export class TipsService {

    private controller = 'news';

    constructor(private _http: Http, private _httpUtil: HttpUtilService) {
    }

    listAll(): Observable<any> {
        return this._http
        .get(this._httpUtil.url(this.controller + '/list'))
        .map(res => res.json())
		.catch(err => Observable.throw(err.message));
	}

    listAllLimit(limit: number): Observable<any> {
        return this._http
        .get(this._httpUtil.url(this.controller + '/list/' + limit))
        .map(res => res.json())
		.catch(err => Observable.throw(err.message));
	}

    getItem(slug: string): Observable<any> {
        return this._http
        .get(this._httpUtil.url(this.controller + '/slug/' + slug))
        .map(res => res.json())
        .catch(err => Observable.throw(err.message));
    }
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/tips/tips.service.ts